import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { AppConfiguration } from './app-config';
import { AppConstants } from './app-constants';


@Injectable()
export class AppConfigService {
  private config: AppConfiguration;
  private constants: AppConstants;

  constructor(private http: HttpClient) { }

  loadConfig(url: string) {
    return new Promise<void>(resolve => {
      this.http.get<AppConfiguration>(url)
        .subscribe(config => {
          this.config = config;
          this.config.apiServiceBaseUri = '';
          this.config.apiServiceBaseUri = environment.apiServiceBaseUri;
          this.config.azureBlobStorage = environment.azureBlobStorage;
          this.config.azureBlobQueue = environment.azureBlobQueue;
          resolve();
        });
    });
  }

  loadConstants(url: string) {
    return new Promise<void>(resolve => {
      this.http.get<AppConstants>(url)
        // tslint:disable-next-line: deprecation
        .subscribe(constants => {
          this.constants = constants;
          resolve();
        });
    });
  }

  getConfiguration(): AppConfiguration {
    return this.config;
  }

  getConstants(): AppConstants {
    return this.constants;
  }
}
